<script>

import {useMediaStore} from "@/globalStorage";

export default {
  name: "MainFooter",
  props: {
    isFormSubmitted: Boolean, // Dies deklariert die erwartete Prop
    currentStep: {
      type: [String, Number], // Angenommen, es kann ein String oder eine Zahl sein
      default: 'Intro'
    },
  },
  data() {
    return {
      showElement: false,
      openedShare: false,
      openedLanguage: false,
      intropopup: null,
      stepString: "Intro",
      volumeMuted: false,
      currentUrl: null,
      mediaStore: useMediaStore()
    }
  },
  watch: {
    isFormSubmitted(showThreeJs) {
      if (showThreeJs === true) {
        this.showElement = true;
        this.$refs.audioPlayer.play();
        this.$refs.audioPlayer.volume = 1;
      }
    },
    currentStep() {
      this.setCurrentStep();
    },
  },
  computed: {
    isAudioMuted() {
      const mediaStore = useMediaStore();
      return mediaStore.isAudioMuted;
    }
  },
  mounted: function () {
    this.$refs.audioPlayer.volume = 0;
    this.currentUrl = window.location.href;
    this.currentUrl = encodeURI(this.currentUrl);
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    generateMailtoLink() {
      const subject = encodeURIComponent(`${this.$t('share.title')}`);
      const body = encodeURIComponent(`${this.$t('share.content')} ${this.currentUrl}`);
      return `mailto:?subject=${subject}&body=${body}`;
    },
    handleVisibilityChange() {
      const mediaStore = useMediaStore();
      if (document.hidden) {
        mediaStore.muteAudio();
      } else {
        mediaStore.unmuteAudio();
      }
    },
    changeLanguage(language) {
      const languages = ["en", "de", "tr", "ja",'cn'];
      if (languages.includes(language)) {
        this.$i18n.locale = language;
        this.$cookies.set('language', this.$i18n.locale);
        console.log(language);
        this.$forceUpdate();

      }
    },
    getFlagSrc() {
      const flagMap = {
        en: require("@/assets/img/flag_en.svg"),
        de: require("@/assets/img/flag_de.svg"),
        ja: require("@/assets/img/flag_jp.svg"),
        cn: require("@/assets/img/flag_cn.svg"),
        tr: require("@/assets/img/flag_tr.svg"),
      };

      return flagMap[this.$i18n.locale] || flagMap.en; // Fallback auf Englisch, falls Sprache nicht gefunden wird
    },
    shareToggle() {
      this.openedShare = !this.openedShare;
    },
    languageToggle() {
      this.openedLanguage = !this.openedLanguage;
      console.log(this.openedLanguage)
    },
    handleClickOutside(event) {
      if (this.$refs.shareToggle && !this.$refs.shareToggle.contains(event.target)) {
        this.openedShare = false;
      }
      if ((this.$refs.languageToggle && !this.$refs.languageToggle.contains(event.target))) {
        this.openedLanguage = false;
      }
    },
    closeOverlay() {
      this.$emit('closeOverlay');
      this.$refs.audioPlayer.play();
      this.$refs.audioPlayer.volume = !this.volumeMuted;
    },
    setCurrentStep() {
      if (typeof this.currentStep === 'number') {
        this.stepString = "Step " + (this.currentStep - 1);
      } else {
        this.stepString = this.currentStep
      }
    },
    changeVolume() {
      this.volumeMuted = !this.volumeMuted;

      this.$emit('volumeMuted', this.volumeMuted);
      // this.$refs.audioPlayer.volume = !this.volumeMuted;

      if (this.mediaStore.isAudioMuted) {
        this.mediaStore.unmuteAudio();
      } else {
        this.mediaStore.muteAudio();
      }
    },
    openControlsExplained() {
      this.$emit('toggleSmallPopup', {opened: true, step: 'controlsexplained'})
    }
  },
}
</script>

<template>
  <footer>
    <div style="pointer-events:none;">
      <p v-if="showElement" @click="openControlsExplained" style="pointer-events:all;"
         :class="{ 'button multistepindex': this.stepString != '', 'controlsexplained': this.stepString == ''}"
         href="#">
        <span v-if="this.stepString != ''">{{ this.stepString }}</span>
        <span v-else><img src="@/assets/img/360.png"/>{{ $t('general.help') }}</span>
      </p>
      <div v-if="!showElement" @click="languageToggle" ref="languageShower" class="languagechanger"
           style="pointer-events: all; align-items: center;display: flex;gap: 10px;">
        <img :src="getFlagSrc()"/>
        <span>{{ $t("general.changeLanguage") }}</span>
      </div>
    </div>
    <div ref="intropopup" style="display:none" class="dynamicspeechbubble overlay">
        <span @click="closeOverlay" class="closeoverlay">
<svg xmlns="http://www.w3.org/2000/svg" width="22.945" height="22.945" viewBox="0 0 22.945 22.945">
  <g id="Gruppe_7895" data-name="Gruppe 7895" transform="translate(1.414 1.414)">
    <line id="Linie_4" data-name="Linie 4" x2="20.117" y2="20.117" transform="translate(0 0)" fill="none" stroke="#fff"
          stroke-linecap="round" stroke-width="2"/>
    <line id="Linie_5" data-name="Linie 5" x2="20.117" y2="20.117" transform="translate(20.117 0) rotate(90)"
          fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
  </g>
</svg>
</span>
      <p>{{ $t('mainFooter.bubble') }}
      </p>
      <div ref="button1">
        <a @click="closeOverlay" class="button nextstep getGuideStep" href="#">
          <span>{{ $t('mainFooter.button') }}</span>
        </a>
      </div>
    </div>
    <div class="social-share-wrapper">
      <div class="social-share" :class="{ 'active': openedLanguage }">
        <div @click="languageToggle" ref="languageToggle" class="toggle">
          <a class="button  buttonshare" href="#">
            <img style="width:24px;height:24px;" src="@/assets/img/language.png"/>
          </a>
        </div>
        <li style="--i:0;--clr:#1877f2">
          <a href="#" @click="changeLanguage('de')">
            <img src="@/assets/img/flag_de.svg"/>
          </a>
        </li>
        <li style="--i:1;--clr:#0a66c2">
          <a href="#" @click="changeLanguage('en')">
            <img src="@/assets/img/flag_en.svg"/>
          </a>
        </li>
        <li style="--i:2;--clr:#ff9900">
          <a href="#" @click="changeLanguage('cn')">
            <img src="@/assets/img/flag_cn.svg"/>
          </a>
        </li>
        <li style="--i:3;--clr:#ff9900">
          <a href="#" @click="changeLanguage('tr')">
            <img src="@/assets/img/flag_tr.svg"/>
          </a>
        </li>
        <li style="--i:4;--clr:#ff9900">
          <a href="#" @click="changeLanguage('ja')">
            <img src="@/assets/img/flag_jp.svg"/>
          </a>
        </li>

      </div>
      <div class="social-share" :class="{ 'active': openedShare }">
        <div @click="shareToggle" ref="shareToggle" class="toggle">
          <a class="button  buttonshare" href="#">
            <img style="width:24px;height:24px;" src="@/assets/img/share.png"/>
          </a>
        </div>
        <div class="">
          <a @click="changeVolume" class="button buttonshare" href="#">
            <img v-if="!volumeMuted" style="width:24px;height:24px;" src="@/assets/img/volume.png"/>
            <!--              <img  style="width:24px;height:24px;" src="@/assets/img/volume.png"/>-->
            <svg v-if="volumeMuted" style="width:24px;height:24px;" xmlns="http://www.w3.org/2000/svg" width="24"
                 height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round"
                 class="icon-tabler icons-tabler-outline icon-tabler-volume-off">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M15 8a5 5 0 0 1 1.912 4.934m-1.377 2.602a5 5 0 0 1 -.535 .464"/>
              <path d="M17.7 5a9 9 0 0 1 2.362 11.086m-1.676 2.299a9 9 0 0 1 -.686 .615"/>
              <path
                  d="M9.069 5.054l.431 -.554a.8 .8 0 0 1 1.5 .5v2m0 4v8a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l1.294 -1.664"/>
              <path d="M3 3l18 18"/>
            </svg>
          </a>
        </div>

        <li style="--i:0;--clr:#1877f2">
          <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=' + this.currentUrl">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 48 48">
              <path fill="#3F51B5"
                    d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"></path>
              <path fill="#FFF"
                    d="M34.368,25H31v13h-5V25h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H35v4h-2.287C31.104,17,31,17.6,31,18.723V21h4L34.368,25z"></path>
            </svg>
          </a>
        </li>
        <li style="--i:1;--clr:#0a66c2">
          <a target="_blank" :href="'https://www.linkedin.com/shareArticle?url=' + this.currentUrl">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 48 48">
              <path fill="#0288D1"
                    d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"></path>
              <path fill="#FFF"
                    d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"></path>
            </svg>
          </a>
        </li>
        <li style="--i:2;--clr:#000000">
          <a target="_blank" :href="generateMailtoLink()">
            <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 viewBox="0 0 75.294 75.294" xml:space="preserve">
<g>
	<path d="M66.097,12.089h-56.9C4.126,12.089,0,16.215,0,21.286v32.722c0,5.071,4.126,9.197,9.197,9.197h56.9
		c5.071,0,9.197-4.126,9.197-9.197V21.287C75.295,16.215,71.169,12.089,66.097,12.089z M61.603,18.089L37.647,33.523L13.691,18.089
		H61.603z M66.097,57.206h-56.9C7.434,57.206,6,55.771,6,54.009V21.457l29.796,19.16c0.04,0.025,0.083,0.042,0.124,0.065
		c0.043,0.024,0.087,0.047,0.131,0.069c0.231,0.119,0.469,0.215,0.712,0.278c0.025,0.007,0.05,0.01,0.075,0.016
		c0.267,0.063,0.537,0.102,0.807,0.102c0.001,0,0.002,0,0.002,0c0.002,0,0.003,0,0.004,0c0.27,0,0.54-0.038,0.807-0.102
		c0.025-0.006,0.05-0.009,0.075-0.016c0.243-0.063,0.48-0.159,0.712-0.278c0.044-0.022,0.088-0.045,0.131-0.069
		c0.041-0.023,0.084-0.04,0.124-0.065l29.796-19.16v32.551C69.295,55.771,67.86,57.206,66.097,57.206z"/>
</g>
</svg>
          </a>
        </li>

      </div>

    </div>


  </footer>

  <audio :muted="isAudioMuted" ref="audioPlayer" autoplay loop playsinline>
    <source src="@/assets/video/webspecial_atmosphere_sound.mp3" type="audio/mp3"/>
    Your browser does not support the audio element.
  </audio>
</template>

<style lang="scss" scoped>
$mainblue: #015672;
$yellow: #FDBE1F;
$contentBG: #F5F5F5;
$contentBorder: #EBEBEB;
@import 'src/assets/css/layout/footer';

.languagechanger {
  //cursor: pointer;
  display: inline-flex;
  gap: 5px;
  @media screen and (max-width: 640px) {
    span {
      color: #fff;
    }
  }
  @media screen and (max-width: 520px) {
    span {
      display: none;
    }
  }

  span {
    color: #fff
  }

  transform: scale(1);
  transition: 0.3s;

  //&:hover {
  //  transform: scale(1.2);
  //}
}

.button {
  &.getGuideStep {
    margin: 0px;
  }
}

.controlsexplained {
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: 0.3s;
  transform: scale(1);
  line-height: 1.2em;

  &:hover {
    transform: scale(1.1);
  }

  span {
    display: flex;
    align-items: centeR;
    gap: 15px;
  }

  img {
    width: 50px;
  }

  @media screen and (max-width: 640px) {
    display: none;
  }
}

.dynamicspeechbubble {
  gap: 0px !important;
  flex-wrap: wrap;
}

.closeoverlay {
  padding: 10px;
  background: $mainblue;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  position: absolute;
  right: 35px;
  top: 35px;
  border-radius: 10px;
  transition: 0.3s;
  box-sizing: border-box;
  z-index: 2;

  svg {
    width: 80%;
    height: auto;
  }

  &:hover {
    cursor: pointer;
    background: $yellow;
  }

  .dynamicspeechbubble & {
    right: 35px;
    top: 25px;
    width: 35px;
    height: 35px;
    @media screen and (max-width: 768px) {
      right: 15px;
      top: 0;
      transform: translateY(-50%);
    }
  }

  @media screen and (max-width: 768px) {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 35px;
    top: 26px;
  }
}
</style>
